import React, { useState } from 'react';
import PrivacySidebar from './PrivacySidebar';
import FooterTrustChat from '../../components/common/FooterTrustChat';
import Navbar from '../../components/common/Navbar';
import PrivacySection1 from './PrivacySection1';
import PrivacySection2 from './PrivacySection2';

function PrivacyPolicy() {
  const [showFirst, setShowFirst] = useState(true);
  const [showSecond, setShowSecond] = useState(false);

  return (
    <div className="Privacy-Policy-Main-Container">
      <div className="PrivacyPolicy-Header-Container">
        <Navbar />
      </div>
      <div className="PrivacyPolicy-Container">
        <div className="PrivacyPolicy-SideContainer">
          <PrivacySidebar
            setShowFirst={setShowFirst}
            setShowSecond={setShowSecond}
          />
        </div>
        {showFirst && <PrivacySection1 />}
        {showSecond && <PrivacySection2 />}
      </div>
      <div className="PrivacyPolicy-Footer">
        <FooterTrustChat />
      </div>
    </div>
  );
}

export default PrivacyPolicy;
